export default "__VITE_ASSET__DuXF30KG__"